import script from "./PelLoanOptionsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PelLoanOptionsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PelLoanOptionsHeader.vue?vue&type=style&index=0&id=065dbbfe&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065dbbfe"]])

export default __exports__